var FiasData =
/** @class */
function () {
  function FiasData(data) {
    this.data = data;
  }

  Object.defineProperty(FiasData.prototype, "name", {
    get: function get() {
      var data = this.data;

      if (FiasData.isAddressObject(data)) {
        return data.name;
      } else if (FiasData.isStead(data)) {
        return data.number;
      } else if (FiasData.isHouse(data)) {
        return data.number || data.structureNumber || data.buildingNumber || '';
      } else if (FiasData.isGarHouse(data)) {
        return data.houseNum || '';
      } else if (FiasData.isRoom(data)) {
        return data.flatNumber;
      }

      return '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "abbreviation", {
    get: function get() {
      return FiasData.isAddressObject(this.data) ? this.data.abbreviation : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "code", {
    get: function get() {
      return FiasData.isAddressObject(this.data) && this.data.code || '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "number", {
    get: function get() {
      return (FiasData.isStead(this.data) || FiasData.isHouse(this.data)) && this.data.number ? this.data.number : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "structureNumber", {
    get: function get() {
      return FiasData.isHouse(this.data) && this.data.structureNumber ? this.data.structureNumber : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "buildingNumber", {
    get: function get() {
      return FiasData.isHouse(this.data) && this.data.buildingNumber ? this.data.buildingNumber : '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "fiasId", {
    get: function get() {
      return this.data.fiasId;
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "parentFiasIds", {
    get: function get() {
      if (!this.data) {
        return [];
      }

      var _a = this.data,
          parentFiasId = _a.parentFiasId,
          parentFiasIds = _a.parentFiasIds;
      return parentFiasIds || (parentFiasId ? [parentFiasId] : []);
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "postalCode", {
    get: function get() {
      return this.data && this.data.postalCode || '';
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "estateStatus", {
    get: function get() {
      if (FiasData.isHouse(this.data)) {
        return this.data.estateStatus;
      }
    },
    enumerable: true,
    configurable: true
  });
  Object.defineProperty(FiasData.prototype, "structureStatus", {
    get: function get() {
      if (FiasData.isHouse(this.data)) {
        return this.data.structureStatus;
      }
    },
    enumerable: true,
    configurable: true
  });

  FiasData.isAddressObject = function (data) {
    return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'name') && Object.prototype.hasOwnProperty.call(data, 'abbreviation'));
  };

  FiasData.isStead = function (data) {
    return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'number') && Object.prototype.hasOwnProperty.call(data, 'liveStatus') && !Object.prototype.hasOwnProperty.call(data, 'estateStatus'));
  };

  FiasData.isHouse = function (data) {
    return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'structureStatus') && (Object.prototype.hasOwnProperty.call(data, 'number') || Object.prototype.hasOwnProperty.call(data, 'structureNumber')));
  };

  FiasData.isGarHouse = function (data) {
    return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'houseNum') || Object.prototype.hasOwnProperty.call(data, 'houseType'));
  };

  FiasData.isRoom = function (data) {
    return Boolean(data && Object.prototype.hasOwnProperty.call(data, 'flatType') && Object.prototype.hasOwnProperty.call(data, 'flatNumber') && Object.prototype.hasOwnProperty.call(data, 'liveStatus'));
  };

  return FiasData;
}();

export { FiasData };